// extracted by mini-css-extract-plugin
module.exports = {"VideoContainer":"_08qYzY1ZyiDW0JgO1snydA==","Video":"IxP8gEQr3iiOuxVRHIzLJQ=="};